import { render, staticRenderFns } from "./informationJjjspt.vue?vue&type=template&id=cb692590&scoped=true&"
import script from "./informationJjjspt.vue?vue&type=script&lang=js&"
export * from "./informationJjjspt.vue?vue&type=script&lang=js&"
import style0 from "./informationJjjspt.vue?vue&type=style&index=0&id=cb692590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb692590",
  null
  
)

export default component.exports